import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import LCHero from "./components/LCHero";
import LCContent from "./components/LCContent";
import LCShopSection from "./components/LCShopSection";
import LCFormula from "./components/LCFormula";
import LCRelated from "./components/LCRelated";
import LCBottomCTA from "./components/LCBottomCTA";

export default function LinenCurtainsPage() {
  return (
    <div className="min-h-screen bg-[#FDFAF5]" style={{ fontFamily: "'Inter', sans-serif" }}>
      <Navbar />
      <main>
        <LCHero />
        <div className="max-w-screen-xl mx-auto px-8 md:px-16">
          <LCContent />
          <LCShopSection />
          <LCFormula />
        </div>
        <LCRelated />
        <LCBottomCTA />
      </main>
      <Footer />
    </div>
  );
}
